/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Mon 05 Jan 2024 07:55:13
 *
 *******************************************************/
// @flow

import React from 'react';
import { Banner, TextStyle } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';

const ProcessingBanner = props => {
  const { i18n } = props;
  return (
    <Banner status="info">
      {i18n.translate('AdminHTML.SemanticSearch.Banner.autoSync', {
        t1: (
          <TextStyle variation="strong">
            {i18n.translate('AdminHTML.SemanticSearch.Banner.autoSync_t1')}
          </TextStyle>
        )
      })}
    </Banner>
  );
};

export default withI18n()(ProcessingBanner);
